const $inject = [];
const lbaHotelTagSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaHotelTagSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaHotelTagSelect.html')
  }
};

lbaHotelTagSelect.$inject = $inject;

export default lbaHotelTagSelect;



// WEBPACK FOOTER //
// ./src/components/lbaHotelTagSelect/lbaHotelTagSelectDir.js